import { gql } from '@apollo/client'

export const EDIT_EVENT_ATTENDEE = gql`
  mutation EditEventAttendee($inputData: EditEventAttendeeInput!) {
    editEventAttendee(inputData: $inputData) {
      id
    }
  }
`
